import { render } from "./UserVideos.vue?vue&type=template&id=45dac858&scoped=true&ts=true"
import script from "./UserVideos.vue?vue&type=script&lang=ts"
export * from "./UserVideos.vue?vue&type=script&lang=ts"

import "./UserVideos.vue?vue&type=style&index=0&id=45dac858&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dac858"]])

export default __exports__